import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const searchPartListMarks = (
    searchTerm: string
) => async (
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        userId:  userData.smsAuth.userId,
        search: searchTerm,
    }
    const config = {
        headers: { Authorization: `${anchor} ${localStorage.getItem('accessToken')}` }
    }
    try {
        const { data: { status, categories } } = await apiInstance.post('/getPartsSelectSearchMark', params, config)
        if (status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setMarksParts,
                value: {
                    categories
                }
            })
        }

    } catch (e) {
        console.error('load  parts marks failed', e)
    }
}

export default searchPartListMarks
